//import Alpine from 'alpinejs'
//Alpine.start()

//IMPORT THIRD PARTIES
//import { Fancybox } from "@fancyapps/ui";

import { initMenu } from './menu';
import { initSearch } from './search';

//IMPORT FUNCTIONS
if (document.getElementsByClassName('tech-block').length != 0) {

    import('./tech-tabs').then(function (page) {
        page.initTechTabs();
    });
}
if (document.getElementsByClassName('toxic--fancybox').length != 0) {
    import('./fancybox').then(function (page) {
        page.initFancybox();
    });
}
if (document.getElementsByClassName('toxic--swiper').length != 0) {
    import('./swiper').then(function (page) {
        page.initSwiper();
    });
}



//INIT FUNCTIONS
initMenu();
initSearch();